import { render } from "./LoadingBlock.vue?vue&type=template&id=4a265170&scoped=true"
import script from "./LoadingBlock.vue?vue&type=script&lang=js"
export * from "./LoadingBlock.vue?vue&type=script&lang=js"

import "./LoadingBlock.vue?vue&type=style&index=0&id=4a265170&lang=scss&scoped=true"

import exportComponent from "/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a265170"]])

export default __exports__